export default "__VITE_ASSET__bdbbd4d9__"